<script>
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "@/router/views/formcomponet/forminput.vue"; 
import formcheckbox from "@/router/views/formcomponet/formcheckbox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import oresmitatil from "@/models/oresmitatil";
import moment from "moment";
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, oresmitatil],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput, 
    formcheckbox,
    formdate,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("oresmitatil", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.oresmitatilData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("oresmitatil", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.oresmitatilData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <b-modal
    v-model="ModalOpen"
    id="oresmitatil"
    size="lg"
    :title="
      this.AddEdit == 'Edit'
        ? 'Kayıt Düzenle'
        : 'Yeni Kayıt Ekle'
    "
    title-class="font-18"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">  
      
      <forminput
        :FormDataType="FormDataType.Adi"
        :Value="FormData.Adi"
        :v="v$.FormData.Adi"
        @input="FormData.Adi = $event.target.value"
      /> 
      <formdate
        :FormDataType="FormDataType.Gun"
        :Value="FormData.IslemTarGunihi"
        :v="v$.FormData.Gun"
        @input="FormData.Gun = $event.target.value"
      />
      <formcheckbox
        :FormDataType="FormDataType.Ozel"
        :Value="FormData.Ozel"
        :v="v$.FormData.Ozel"
        @input="FormData.Ozel = $event.target.checked"
      />
      <formcheckbox
        :FormDataType="FormDataType.Yarimgun"
        :Value="FormData.Yarimgun"
        :v="v$.FormData.Yarimgun"
        @input="FormData.Yarimgun = $event.target.checked"
      />

      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
